(function () {
    const onVideoTriggerClick = function (event) {
        const trigger = event.target.closest('.js-video-trigger');
        if (!trigger) {
            return;
        }

        const card = trigger.closest('.js-video-card');
        if (!card || card.classList.contains('is-playing')) {
            return;
        }

        const iframe = card.querySelector('iframe');
        if (!iframe) {
            return;
        }

        const originalSrc = iframe.getAttribute('data-src') || iframe.getAttribute('src');
        if (!originalSrc) {
            return;
        }

        let nextSrc = originalSrc;
        if (!/autoplay=1/.test(nextSrc)) {
            nextSrc += (nextSrc.indexOf('?') === -1 ? '?' : '&') + 'autoplay=1';
        }

        iframe.setAttribute('src', nextSrc);
        card.classList.add('is-playing');
    };

    document.addEventListener('click', onVideoTriggerClick);
})();
